import React from "react";
import { styled, Typography } from "@mui/material";

const Page = styled("div")`
  display: flex;
  flex-direction: column;
  margin-top: 0px;

  > div:first-of-type {
    color: ${(props) => props.theme.palette.grey[600]};
  }
`;

interface Props {
  heading?: string;
  siteHeading?: string;
  subheading?: string;
  children: any;
}

const FormPage = ({ heading, siteHeading, subheading, children }: Props) => (
  <Page>
    {heading ? (
      <Typography variant="h5" data-test-id="heading">
        {heading}
      </Typography>
    ) : null}
    <Typography data-test-id="site-heading" variant="subtitle1">
      {siteHeading}
    </Typography>
    <div>{subheading}</div>
    <div>{children}</div>
  </Page>
);

export default FormPage;
